import { render, staticRenderFns } from "./testMindAr.vue?vue&type=template&id=e32bfdc4&scoped=true&"
import script from "./testMindAr.vue?vue&type=script&lang=js&"
export * from "./testMindAr.vue?vue&type=script&lang=js&"
import style0 from "./testMindAr.vue?vue&type=style&index=0&id=e32bfdc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32bfdc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e32bfdc4')) {
      api.createRecord('e32bfdc4', component.options)
    } else {
      api.reload('e32bfdc4', component.options)
    }
    module.hot.accept("./testMindAr.vue?vue&type=template&id=e32bfdc4&scoped=true&", function () {
      api.rerender('e32bfdc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/mindAr/testMindAr.vue"
export default component.exports